module.exports = __webpack_public_path__ + "img/section-process.a0697910.png";